<template>
  <div>
    <el-select v-model="text"
               :size="size"
               :filterable = "filterable"
               :multiple="multiple"
               :placeholder="placeholder"
               @change="handleChange"
               :disabled="disabled"
               :clearable="clearable"
               style="width: 100%">
      <el-option
        v-for="item in dataSource"
        :key="item.dictId"
        :label="item[labelKey]"
        :value="item[valueKey]">
      </el-option>
    </el-select>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  import CompanyInfo from "@/api/common/CompanyInfo";
  import ArrayUtil from '@/util/arr';
  export default {
    name: 'SelectCompany',
    data() {
      return {
        dataSource: [],
        text: ''
      }
    },
    props: {
      value:[String, Number, Array],

      // 当前公司id,如果为空，则为当前登录人公司ID
      currentCompanyId: {
        type: String
      },
      // 要查询的公司类型： all: 全部;  selfAndChild: 当前公司及其子公司;
      // child: 当前公司的子公司; second: 二级公司
      companyType:{
        type: String,
        default: 'allCompany'
      },

      // 是否加入 “全部” 虚拟元素
      showAllItem:{
        type: Boolean,
        default: false
      },
      size: {
        type: String,
        default: 'medium'
      },

      disabled: {
        type: Boolean,
        default: false
      },

      multiple: {
        type: Boolean,
        default: false
      },

      clearable: {
        type: Boolean,
        default: false
      },

      filterable: {
        type: Boolean,
        default: false
      },

      placeholder: {
        type: String,
        default: '请选择'
      },

      labelKey: {
        type: String,
        default: 'name'
      },
      valueKey: {
        type: String,
        default: 'companyId'
      }
    },

    methods: {
      findCompany() {
        let companyInfo = new CompanyInfo();
        let companyId = this.currentCompanyId ? this.currentCompanyId : this.companyId;
        if (this.companyType == 'all') {  //所有公司
          companyInfo.getAllCompany({"companyId": companyId}).then(res => {
            if (res.code == 1) {
              this.dataSource = res.data;
              this.text = this.value;
              this.addAllItem();
            }
          })
        }else if (this.companyType == 'selfAndChild') { //当前登录人及其子公司
          companyInfo.getSubComany({companyId: companyId}).then(res => {
            if (res.code == 1) {
              this.dataSource = res.data;
              this.text = this.value;
              this.addAllItem();
            }
          })
        }else if (this.companyType == 'child') { //二级公司为当前公司集团公司为获取二级公司
          companyInfo.getCompanyLevelTwoIfYes({companyId: companyId}).then(res => {
            if (res.code == 1) {
              this.dataSource = res.data;
              this.text = this.value;
              this.addAllItem();
            }
          })
        }
        else if (this.companyType == 'secondCompany') { //二级公司
          companyInfo.getSecondCompany({companyId: companyId}).then(res => {
            if (res.code == 1) {
              this.dataSource = res.data;
              this.text = this.value;
              this.addAllItem();
            }
          })
        }
        else if (this.companyType == 'groupCompanyAndselfCompany') { //集团公司及当前登录人公司
          companyInfo.getCompanyAndGroupCompany({companyId: companyId}).then(res => {
            if (res.code == 1) {
              this.dataSource = res.data;
              this.text = this.value;
              this.addAllItem();
            }
          })
        }
        else if (this.companyType == 'subCompany') {
          companyInfo.getSubCompanyByCompanyId({companyId: companyId}).then(res => {
            if (res.code == 1) {
              this.dataSource = res.data;
              this.text = this.value;
              this.addAllItem();
            }
          })
        }
      },
      addAllItem(){
        if (this.showAllItem) {
          let item = {
            'companyId': '',
            'name': '全部'
          }
          this.dataSource.unshift(item);
          if(!this.value){
            this.text = '';
          }
        }
      },
      //选择回调
      handleChange(val) {
        this.text = val;
        this.$emit("input", val);

        let valueKey = this.valueKey;
        if(ArrayUtil.isArray(val)){
          // 如果是多选
          let selectVals = [];
          this.dataSource.forEach(function(item) {
            if(val.indexOf(item[valueKey]) != -1){
              selectVals.push(item);
            }
          });
          this.$emit("on-change", selectVals);
        }else{
          // 如果是单选
          let company = {};
          this.dataSource.forEach(function(item) {
            if(item[valueKey] == val){
              company = item;
            }
          });
          this.$emit("on-change", company);
        }
      }


    },
    created() {
      this.findCompany();
    },
    watch:{
      value(curVal,oldVal){
        this.text = curVal;
      }
    },
    computed: {
      ...mapGetters(["companyId"])
    }
  }
</script>

<style lang="scss">
</style>
